"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";
import { cx } from "class-variance-authority";
import { IoClose } from "react-icons/io5";
import PhoneInput from "react-phone-input-2";
import toast, { Toaster } from "react-hot-toast";

import beforeYouaLeavebg from "../../../../public/assets/General-Img/Home/beforeYouaLeavebg.webp";
import beforeYouaLeavebgSmall from "../../../../public/assets/General-Img/Home/beforeYouaLeavebg-small.webp";
import { useRouter } from "next/navigation";

const BeforeYouLeave = ({ contactInfoTags }) => {
    const router = useRouter();

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [hasPopupShownThisSession, setHasPopupShownThisSession] =
        useState(false);
    const [submitStatus, setSubmitStatus] = useState("PENDING");
    const [phoneNumber, setPhoneNumber] = useState("");
    // contact info
    const [contactInfo, setContactInfo] = useState({
        name: "",
        email: "",
        projectDescription: "",
        contactInfo: {
            contactNumberTag: contactInfoTags?.contactNumber[0].id,
            contactNumber: "",
            countryName: "",
            dialCode: "",
            countryCode: "",
        },
    });
    const [captchaInput, setCaptchaInput] = useState("");
    const [captchaMessage, setCaptchaMessage] = useState(false);

    const changePhone = (value, data) => {
        // const input = e.target.value
        setContactInfo((prevContactInfo) => ({
            ...prevContactInfo,
            contactInfo: {
                ...prevContactInfo.contactInfo,
                contactNumber: value,
                countryName: data.name || "United States",
                dialCode: data.dialCode || "1",
                countryCode: data.countryCode || "us",
            },
        }));
    };

    // contact info changer
    const changeContactInfo = async (key, value) => {
        setContactInfo({
            ...contactInfo,
            [key]: value,
        });
    };

    // Math Captcha States
    const [num1] = useState(Math.floor(Math.random() * 10));
    const [num2] = useState(Math.floor(Math.random() * 10));

    useEffect(() => {
        const handleMouseLeave = (event) => {
            if (!hasPopupShownThisSession && event.clientY <= 0) {
                setIsPopupOpen(true);
                setTimeout(() => setIsVisible(true), 50);
                setHasPopupShownThisSession(true);
            }
        };

        document.addEventListener("mouseleave", handleMouseLeave);

        return () => {
            document.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, [hasPopupShownThisSession]);

    const closePopup = () => {
        setIsVisible(false);
        setTimeout(() => {
            setIsPopupOpen(false);
        }, 300);
    };

    // common input styles
    const BASE_INPUT = cx(
        "text-black bg-white placeholder:text-[#A1A6B6] font-manrope font-normal rounded-lg focus:outline-none py-3 px-4 text-sm"
    );

    const validateInputs = () => {
        let isValid = true;

        // Check if all fields are empty
        const allFieldsEmpty =
            !contactInfo.name.trim() &&
            !contactInfo.email.trim() &
                !(
                    contactInfo.contactInfo.contactNumber.trim() ||
                    phoneNumber.trim()
                ) &&
            !contactInfo.projectDescription.trim();

        if (allFieldsEmpty) {
            toast.error("Please fill out the form correctly.");
            return false;
        }

        // Validate individual fields
        if (!contactInfo.name.trim()) {
            toast.error("Name is required.");
            isValid = false;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(contactInfo.email)) {
            toast.error("Invalid email address.");
            isValid = false;
        }

        // Validate phone number
        if (
            !(
                contactInfo.contactInfo.contactNumber.trim() ||
                phoneNumber.trim()
            ) &&
            phoneNumber.length < 10
        ) {
            toast.error("Invalid phone number.");
            isValid = false;
        }

        if (!contactInfo.projectDescription.trim()) {
            toast.error("Project description is required.");
            isValid = false;
        }

        return isValid;
    };

    const submitContactInfo = async () => {
        setSubmitStatus("SUBMITTING");

        if (!validateInputs()) {
            setSubmitStatus("PENDING");
            return false;
        }
        if (!captchaInput.trim()) {
            toast.error("CAPTCHA is required.");
            setSubmitStatus("PENDING");

            return;
        }
        if (parseInt(captchaInput) !== num1 + num2) {
            toast.error("Invalid CAPTCHA.");
            setSubmitStatus("PENDING");

            return;
        }

        try {
            // submitting form
            const submittingForm = await fetch(
                `${process.env.NEXT_PUBLIC_STRAPI_URL}/api/small-contact-forms`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${process.env.NEXT_PUBLIC_SUPER_TOKEN}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        data: {
                            ...contactInfo,
                        },
                    }),
                }
            );
            const submittingFormData = await submittingForm.json();
            setPhoneNumber("");
            if (submittingFormData.data === null) {
                setSubmitStatus("ERROR");
                return false;
            } else {
                setSubmitStatus("SUCCESS");
                router.push("/thank-you-for-your-consultation");
                return true;
            }
        } catch (err) {
            console.log(err);
            return false;
        }
    };

    return (
        <>
            <div className="relative">
                {isPopupOpen && (
                    <>
                        <div
                            className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999999] transition-opacity duration-300 ${
                                isVisible ? "opacity-100" : "opacity-0"
                            }`}
                            onClick={closePopup}
                        >
                            {/* modal  */}
                            <div
                                className={`bg-white shadow-lg w-[80%] h-[80%] sm:h-auto sm:w-auto text-center transform transition-all duration-300 rounded-[11px] overflow-x-hidden select-none ${
                                    isVisible ? "scale-100" : "scale-90"
                                }`}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* modal content */}
                                <div className="flex lg:flex-row flex-col gap-5 xl:gap-7 rounded-[20px] overflow-hidden w-full p-6">
                                    {/* left side */}
                                    <span
                                        className="lg:hidden block absolute right-0.5 top-0.5 cursor-pointer border border-[#F3F3F3] p-1 rounded"
                                        onClick={closePopup}
                                    >
                                        <IoClose className="text-base text-black" />
                                    </span>
                                    <Image
                                        src={beforeYouaLeavebg}
                                        alt="beforeYouaLeavebg"
                                        className="w-full lg:w-1/2 !h-[20%] lg:h-full lg:block hidden"
                                    />
                                    <Image
                                        src={beforeYouaLeavebgSmall}
                                        alt="beforeYouaLeavebg"
                                        className="w-full lg:w-1/2 !h-[20%] lg:h-full lg:hidden block"
                                    />
                                    <span
                                        className="lg:hidden block absolute -right-4 -top-4 cursor-pointer border border-[#F3F3F3] p-1 rounded"
                                        onClick={closePopup}
                                    >
                                        <IoClose className="text-base text-black" />
                                    </span>

                                    {/* right side */}
                                    <div className=" w-full relative">
                                        <span
                                            className="lg:block hidden absolute -right-4 -top-4 cursor-pointer border border-[#F3F3F3] p-1 rounded"
                                            onClick={closePopup}
                                        >
                                            <IoClose className="text-base text-black" />
                                        </span>

                                        <div className=" flex flex-col gap-3.5 text-[#A1A6B6] text-lg leading-5 font-medium">
                                            <h2 className="text-xl text-black font-bold w-[70%] !text-start">
                                                Wait! Before You Go...
                                            </h2>
                                            <div className="flex flex-col sm:flex-row lg:flex-col gap-3.5 w-full">
                                                <input
                                                    autoComplete="off"
                                                    placeholder="Name"
                                                    className={cx(
                                                        BASE_INPUT,
                                                        "w-full"
                                                    )}
                                                    style={{
                                                        boxShadow:
                                                            "0px 0px 2.81px 0px #410EAD30",
                                                    }}
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    value={contactInfo.name}
                                                    onChange={(e) =>
                                                        changeContactInfo(
                                                            "name",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <input
                                                    autoComplete="off"
                                                    placeholder="Email"
                                                    className={cx(
                                                        BASE_INPUT,
                                                        "w-full"
                                                    )}
                                                    style={{
                                                        boxShadow:
                                                            "0px 0px 2.81px 0px #410EAD30",
                                                    }}
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={contactInfo.email}
                                                    onChange={(e) =>
                                                        changeContactInfo(
                                                            "email",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </div>
                                            <input
                                                type="text"
                                                placeholder="Describe Your Project/Idea In Brief"
                                                className={cx(BASE_INPUT)}
                                                style={{
                                                    boxShadow:
                                                        "0px 0px 2.81px 0px #410EAD30",
                                                }}
                                                id="projectDescription"
                                                name="projectDescription"
                                                value={
                                                    contactInfo.projectDescription
                                                }
                                                onChange={(e) =>
                                                    changeContactInfo(
                                                        "projectDescription",
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <div
                                                className={cx(
                                                    "text-black bg-white placeholder:text-[#A1A6B6] font-manrope font-normal rounded-lg focus:outline-none py-1 px-4 text-sm flex flex-row w-full"
                                                )}
                                                style={{
                                                    boxShadow:
                                                        "0px 0px 2.81px 0px #410EAD30",
                                                }}
                                            >
                                                <PhoneInput
                                                    type="text"
                                                    country={"us"}
                                                    value={phoneNumber}
                                                    onChange={changePhone}
                                                    inputProps={{
                                                        name: "phone",
                                                        required: true,
                                                        id: "phone",
                                                        "aria-label":
                                                            "Phone number",
                                                        required: true,
                                                    }}
                                                    placeholder=""
                                                />
                                            </div>

                                            {/* Math Captcha */}
                                            <div className="flex items-center gap-3">
                                                <span className="text-black text-lg font-bold">
                                                    {num1} + {num2} =
                                                </span>
                                                <input
                                                    type="number"
                                                    className={cx(
                                                        BASE_INPUT,
                                                        "w-24 appearance-none"
                                                    )}
                                                    style={{
                                                        boxShadow:
                                                            "0px 0px 2.81px 0px #410EAD30",
                                                    }}
                                                    onChange={(e) =>
                                                        setCaptchaInput(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                {captchaMessage && (
                                                    <p className="text-sm text-red-500">
                                                        {captchaMessage}
                                                    </p>
                                                )}
                                            </div>

                                            <button
                                                onClick={() =>
                                                    submitContactInfo()
                                                }
                                                className={cx(
                                                    "common-blue-button-style !py-2 !px-10 !tracking-wide text-xl mt-2.5 mb-5 lg:mb-0"
                                                )}
                                            >
                                                {submitStatus ===
                                                "SUBMITTING" ? (
                                                    <div
                                                        className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-white border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                                                        role="status"
                                                    >
                                                        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                                                            Loader
                                                        </span>
                                                    </div>
                                                ) : (
                                                    "Submit Now"
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Toaster
                                position="top-center"
                                reverseOrder={false}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default BeforeYouLeave;
